import { Realtime } from './../providers/realtime';
import { TimePipe } from './../pipes/time.pipe';
import { LoginPage } from './../pages/login/login';
import { AppFacade } from './../facade/app.facade';
import { DockModal } from './../components/dock-modal/dock-modal';
import { DockItem } from './../components/dock-item/dock-item';
import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { reducers, metaReducers } from '../states/app.reducer';

import { TielbekeApp } from './app.component';
import { HomePage } from '../pages/home/home';
import { ResourceProvider } from '../providers/resource/resource';
import { AuthProvider } from '../providers/auth/auth';
import { EnvironmentsModule } from "./environment-variables/environment-variables.module";
import { BuildingPlanComponent } from '../components/building-plan/building-plan';
import { ModalProvider } from '../providers/modal/modal';
import { ThreeProvider } from '../providers/three/three';
import { SelectSearchableModule } from '../components/select/select-module';


@NgModule({
    declarations: [
        TielbekeApp,
        HomePage,
        LoginPage,
        DockModal,
        DockItem,
        TimePipe,
        BuildingPlanComponent
    ],
    imports: [
        BrowserModule,
        IonicModule.forRoot(TielbekeApp, {
            mode: 'md',
        }),
        EnvironmentsModule,
        StoreModule.forRoot(reducers, { metaReducers }),
        StoreDevtoolsModule.instrument({ maxAge: 5 }),
        HttpClientModule,
        SelectSearchableModule,
    ],
    bootstrap: [IonicApp],
    entryComponents: [
        TielbekeApp,
        HomePage,
        LoginPage,
        DockModal,
        DockItem,
    ],
    providers: [
        { provide: ErrorHandler, useClass: IonicErrorHandler },
        AppFacade,
        ResourceProvider,
        AuthProvider,
        Realtime,
        ModalProvider,
        ThreeProvider
    ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts